import axios from "axios";

export default function getAllLoyaltyPoint({
    length,
    start,
    column,
    order,
    search,
    product,
}) {
    return new Promise((resolve, reject) => {
        axios.get("/campaign/api/admin/campaigns",
            {
                params: {
                    limit: length,
                    skip: start,
                    sortBy: column,
                    order: order,
                    search: search,
                    product: product,
                }
            })
            .then(response => resolve(response.data))
            .catch(error => reject(error.response.data))
    })
}
